import { formatNum } from '@/util/number';
import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields() {
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'cpuUsage', label: 'CPU Usage (%)', class: 'text-center' },
      { key: 'memoryFree', label: 'Memory Free (%)', class: 'text-center' },
      { key: 'spaceFree', label: 'Space Free (%)', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData, (serie) => ({
      cpuUsage: formatNum((serie.cpuUsage * 100), 2),
      memoryFree: formatNum((serie.memoryFree * 100), 2),
      spaceFree: formatNum((serie.spaceFree * 100), 2),
    }));
  },
  buildSummary() {
    return {};
  },
};
